export default {
      id: "icon-chat-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.c2f64a3b.svg#icon-chat",
      toString: function () {
        return this.url;
      }
    }